import { render, staticRenderFns } from "./ActionAtom.vue?vue&type=template&id=4264466c&"
import script from "./ActionAtom.vue?vue&type=script&lang=ts&"
export * from "./ActionAtom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports